import { useState } from 'react';
import axios from 'api';
import { useDispatch, useSelector } from 'react-redux';

export const useLazyQuery = (url, config, options) => {
  const dispatch = useDispatch();
  const cache = useSelector(({ cache }) => cache);
  const [result, setResult] = useState({
    loading: false,
    error: undefined,
    data: undefined,
    called: false
  });

  const getData = async config => {
    let getUrl = url;

    if (config?.params?.id) {
      getUrl = `${getUrl}/${config.params.id}`;
      delete config.params.id;
    }

    setResult({
      loading: true,
      error: undefined,
      data: undefined,
      called: false
    });

    const cacheData = cache[getUrl];

    if (cacheData) {
      setResult({
        loading: false,
        error: false,
        data: cacheData,
        called: true
      });
    } else {
      const result = await axios.get(`${getUrl}`, config).catch(err => err);

      if (result.data && !options?.noCache) {
        dispatch({
          type: 'set',
          payload: {
            url: getUrl,
            data: result.data
          }
        });
      }

      setResult({
        loading: false,
        error: result?.error,
        data: result?.data,
        called: true
      });
    }
  };

  return [getData, result];
};
